import './ArticlesGallery/register'
import './MiddleButton/register'
import './Steps/register'
import './MediaWithForms/register'
import './HeroProductPremium/register'
import './List/register'
import './DisclaimerPremium/register'
